import ApiClient from '@services/ApiClient';

export default {
    findStartPlaces(offerType, search) {
        return ApiClient.get(`/places/${offerType}/find/start`, {
            params: search,
        });
    },

    findDestinations(offerType, search) {
        return ApiClient.get(`/places/${offerType}/find/end`, {
            params: search,
        });
    },

    searchBerbusPlaces(params) {
        return ApiClient.get('/places/berbus/search', {
            params,
        });
    },
};
